module.exports = __webpack_public_path__ + "static/media/circle.ea8985da.svg";